import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import SoftTypography from "components/SoftTypography";

const ToolboxDetailSubHeader = ({ title, subtitle }) => {
  return (
    <Box mb={1}>
      <Divider />
      <Box sx={{ lineHeight: "12px" }}>
        <SoftTypography variant="caption" fontWeight="bold" color="dark">
          {title}
        </SoftTypography>
      </Box>
      <Box sx={{ lineHeight: "28px" }}>
        <SoftTypography variant="caption" fontWeight="regular" color="secondary">
          {subtitle}
        </SoftTypography>
      </Box>
    </Box>
  )
}

export default ToolboxDetailSubHeader;